export class CrawlEngine {
	constructor({ maxPages, fetchPage, extractLinks, normalizePostId }) {
		this.maxPages = maxPages;
		this.fetchPage = fetchPage;
		this.extractLinks = extractLinks;
		this.normalizePostId = normalizePostId;
	}

	async crawl(startUrl, depthLimit, onPageFound) {
		const queue = [{ url: startUrl, depth: 0 }];
		const visited = new Set();
		const foundPages = [];

		while (queue.length > 0 && foundPages.length < this.maxPages) {
			const current = queue.shift();

			if (!current || visited.has(current.url)) {
				continue;
			}

			visited.add(current.url);

			try {
				const pageResponse = await this.fetchPage(current.url);
				foundPages.push({
					url: current.url,
					depth: current.depth,
					postId: this.normalizePostId(pageResponse.postId),
					pageType: pageResponse.pageType || 'singular',
					layoutSignals: pageResponse.layoutSignals || null,
					crawledAt: new Date().toISOString()
				});

				if (typeof onPageFound === 'function') {
					onPageFound(foundPages);
				}

				if (current.depth >= depthLimit) {
					continue;
				}

				const links = this.extractLinks(pageResponse.html, current.url);

				for (const nextUrl of links) {
					if (!visited.has(nextUrl)) {
						queue.push({ url: nextUrl, depth: current.depth + 1 });
					}
				}
			} catch {
				continue;
			}
		}

		return foundPages;
	}
}
